import authLayout from './layouts/auth.vue'
import homeLayout from './layouts/home.vue'
import errorLayout from './layouts/error.vue'

export default {
  authLayout,
  homeLayout,
  errorLayout
}